var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 776,
    height: 15,
    viewBox: "0 0 776 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.02523,
    height: 15,
    fill: "#3B494D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 773.638,
    width: 2.02523,
    height: 15,
    fill: "#3B494D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.19165,
    y: 6,
    width: 771.446,
    height: 2,
    fill: "#3B494D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalDivider);
export default __webpack_public_path__ + "static/media/TerminalDivider.2ff00408d18ce6d2f0d5a7a7520063f8.svg";
export { ForwardRef as ReactComponent };